import {
    dunningTypes,
    hydrateFormatSingleDunning,
    hydrateFormatDunnings,
    persistFormatDunnings,
} from './thirddunnings';

const hydratePrefs = (data) => {
    const dunning = {};

    dunningTypes.forEach((type) => {
        if (data.dunnings?.[type]) {
            dunning[type] = hydrateFormatSingleDunning(data.dunnings[type]);
        }
    });
    return {
        currency: {
            id: data.currency?.id,
            code: data.currency?.code,
            symbol: data.currency?.symbol,
        },
        shipping: {
            id: data.carrier?.id,
            name: data.carrier?.label,
        },
        tax: {
            id: data.tax?.id,
            rate: data.tax?.rate,
            label: data.tax?.label,
            isActive: data.tax?.is_active,
            isEcotax: data.tax?.is_ecotax,
        },
        paymentTerm: {
            id: data.payment_term?.id,
            label: data.payment_term?.label,
            xDays: data.payment_term?.x_days,
            endOfMonth: data.payment_term?.end_of_month,
        },
        discount: {
            amount: data.discount?.amount,
            isAmountDiscount: data.discount?.type === 'amount',
            isPercentDiscount: data.discount?.type === 'percent',
        },
        bankAccount: {
            iban: data.bank_account?.iban,
            id: data.bank_account?.id,
            label: data.bank_account?.label,
        },
        discountByRow: data.discount_by_row,
        rateCategory: {
            id: data.rate_category?.id,
            label: data.rate_category?.label,
        },
        payMediums: data.pay_mediums || [],
        dunning,
    };
};

const hydrateMetadata = (data) => {
    const dunning = {};

    dunningTypes.forEach((type) => {
        if (data.dunnings?.[type]) {
            dunning[type] = hydrateFormatDunnings(data.dunnings[type]);
        }
    });

    return {
        bankAccounts: data.bankaccounts,
        shippers: data.carriers,
        dunning,
        payMediums: data.paymediums || [],
        paymentTerms: data.payment_terms || [],
        rateCategories: data.rate_categories || [],
        taxes: data.taxes || [],
    };
};

const persistPrefs = (isSupplier, data) => {
    const result = {
        currency_id: data.currency,
        carrier_id: data.shipper,
        tax_id: data.tax,
        payment_terms: {
            id: data.paymentTerm.id,
            end_of_month: data.paymentTerm.endOfMonth,
        },
        discount: {
            amount: data.discount.input,
            type: data.discount.select,
        },
        bank_account_id: +data.bankAccount || null,
        discount_by_row: data.discountByRow,
        pay_medium_ids: data.payMediums,
    };

    if (data.paymentTerm.code === 'xdays') {
        result.payment_terms.x_days = +data.paymentTerm.xdays;
    }

    if (!isSupplier) {
        result.rate_category_id = data.rateCategory;
        result.dunning = persistFormatDunnings(data.dunning);
    }

    return result;
};

export { hydratePrefs, hydrateMetadata, persistPrefs };
